import React from 'react'
import PropTypes from 'prop-types'
import {useItemVariant} from '@salesforce/retail-react-app/app/components/item-variant'
import {noop} from '@salesforce/retail-react-app/app/utils/utils'
import Remove from 'hec/assets/icons/remove'

const RemoveProductBtn = ({onRemoveItemClick = noop, productIndex}) => {
    const variant = useItemVariant()

    const handleRemoveItem = async () => {
        onRemoveItemClick(variant, productIndex)
    }

    return (
        <button onClick={handleRemoveItem}>
            <Remove className="w-3.5 h-3" />
        </button>
    )
}

RemoveProductBtn.propTypes = {
    onRemoveItemClick: PropTypes.func,
    productIndex: PropTypes.number.isRequired
}

export default RemoveProductBtn
